"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bson_objectid_1 = require("bson-objectid");
function isValidLanguage(language) {
    return language === null || (typeof language === "string") && language.length < 5;
}
exports.isValidLanguage = isValidLanguage;
function isValidAlphanumericStringNoSpecialChar(text) {
    if (text === null) {
        return false;
    }
    const regex = /^\b[A-Za-z0-9]+\b$/;
    return text.match(regex) !== null; // TODO: check
}
exports.isValidAlphanumericStringNoSpecialChar = isValidAlphanumericStringNoSpecialChar;
function isValidEmail(email) {
    if (email === null) {
        return false;
    }
    const regex = /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/;
    return email.match(regex) !== null; // TODO: check
}
exports.isValidEmail = isValidEmail;
/**
 * Returns true when given value is not undefined and not null.
 * @param value
 */
function isDefined(value) {
    return value !== undefined && value !== null;
}
exports.isDefined = isDefined;
function isValidId(id) {
    return bson_objectid_1.default.isValid(id);
}
exports.isValidId = isValidId;
function isValidBoolean(value) {
    return typeof (value) === "boolean";
}
exports.isValidBoolean = isValidBoolean;
function toBoolean(value) {
    if (value === "false") {
        return false;
    }
    return Boolean(value);
}
exports.toBoolean = toBoolean;
function toNumber(value) {
    if (typeof (value) === "string") {
        return Number(value.replace(",", "."));
    }
    else {
        return Number(value);
    }
}
exports.toNumber = toNumber;
function isValidNumber(value) {
    return !isNaN(value);
}
exports.isValidNumber = isValidNumber;
function isValidInteger(value) {
    return Number.isInteger(value);
}
exports.isValidInteger = isValidInteger;
function isValidPositiveInteger(value) {
    return Number.isInteger(value) && value >= 0;
}
exports.isValidPositiveInteger = isValidPositiveInteger;
function isValidStrictlyPositiveInteger(value) {
    return Number.isInteger(value) && value > 0;
}
exports.isValidStrictlyPositiveInteger = isValidStrictlyPositiveInteger;
function isValidPositiveFloatingPoint(value) {
    return isValidNumber(value) && value >= 0;
}
exports.isValidPositiveFloatingPoint = isValidPositiveFloatingPoint;
function isValidStrictlyPositiveFloatingPoint(value) {
    return isValidNumber(value) && value > 0;
}
exports.isValidStrictlyPositiveFloatingPoint = isValidStrictlyPositiveFloatingPoint;
function fuzzyEquals(first, second, DELTA = 0.0001) {
    if (first === second) {
        return true;
    }
    if (first < second + DELTA && first > second - DELTA) {
        return true;
    }
    return false;
}
exports.fuzzyEquals = fuzzyEquals;
/**
 * Runs function f with value as parameter If (value is) Not Undefined
 * @param value
 * @param f
 */
function inu(value, f, g) {
    if (value !== undefined) {
        return f(value);
    }
    else if (g !== undefined) {
        return g();
    }
    else {
        return null;
    }
}
exports.inu = inu;
/**
 * Runs function f with value as parameter If (value is) Not Undefined and not null
 * @param value
 * @param f
 */
function inun(value, f, g) {
    if (value !== undefined && value !== null) {
        return f(value);
    }
    else if (g !== undefined) {
        return g();
    }
    else {
        return null;
    }
}
exports.inun = inun;
/**
 * Runs function f with value as parameter If (value is) not null
 * @param value
 * @param f
 */
function inn(value, f, g) {
    if (value !== null) {
        return f(value);
    }
    else if (g !== undefined) {
        return g();
    }
    else {
        return null;
    }
}
exports.inn = inn;
//# sourceMappingURL=basic.js.map